import React from 'react'

import Header from '../components/Header'
import LoginComponentWrapper from '../components/login/LoginComponentWrapper'

function Login() {
    return (
        <>
            <Header />
            <LoginComponentWrapper />
        </>
    )
}

export default Login